import { render, staticRenderFns } from "./editKnowledgeDocument.vue?vue&type=template&id=7a978e5c&scoped=true"
import script from "./editKnowledgeDocument.vue?vue&type=script&lang=js"
export * from "./editKnowledgeDocument.vue?vue&type=script&lang=js"
import style0 from "./editKnowledgeDocument.vue?vue&type=style&index=0&id=7a978e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a978e5c",
  null
  
)

export default component.exports